<template>
  <div class="prices">
    <md-table v-for="pricelist, i in $store.state.receivedData.pricelists.list" class="prices-table">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">{{ pricelist.title_hr }}</h1>
        </div>
      </md-table-toolbar>
      <md-table-head v-for="price, key in pricelist.prices">{{ key }}. kategorija</md-table-head>
      <md-table-head class="t-align-center">Akcije</md-table-head>
      <md-table-row md-selectable="single" md-auto-select>
        <md-table-cell v-for="price, key in pricelist.prices">
          <span v-if="price > 0">{{ formatCurrency(price) }}</span>
          <span v-else>-</span>
        </md-table-cell>
        <md-table-cell class="small-cell">
          <md-button class="md-raised md-dense md-accent" v-on:click="openDialog(i);">
            Izmjeni
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog v-if="priceCategory !== null" :md-active.sync="$store.state.dialogs.priceChange" class="edit-form">
      <md-dialog-title>Izmjena cijene</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <md-field v-for="price, key in $store.state.receivedData.pricelists.list[priceCategory].prices">
              <label>
                <span v-if="key > 0">{{ `${key}. kategorija (kn)` }}</span>
              </label>
              <md-input required type="number" min="0" :name="key" v-model="priceInput[key]"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
          </div>
          <md-dialog-actions>
            <md-button v-on:click="$store.state.dialogs.priceChange = false">Zatvori</md-button>
            <md-button v-on:click="updatePriceList" class="md-primary">Spremi</md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-card>
    </md-dialog>
  </div>
</template>

<script>
import FormatCurrency from '../../../mixins/format-currency';
export default {
  name: 'Prices',

  mixins: [FormatCurrency],

  data(){
    return{
      priceInput: {},
      priceCategory: null,
    }
  },

  methods: {
    openDialog(i){
      let key = null;
      this.priceCategory = i;
      this.$store.state.dialogs.priceChange = true;
      for(key in this.$store.state.receivedData.pricelists.list[i].prices){
        this.priceInput[key] = this.$store.state.receivedData.pricelists.list[i].prices[key];
      }
    },

    updatePriceList(){
      this.$store.dispatch('updatePricelists', {context: {'prices': this.priceInput}, id: this.$store.state.receivedData.pricelists.list[this.priceCategory].id});

    }
  }
}
</script>

<style lang="scss">
.prices-table{
  margin-top: 100px;
  max-width: calc(100% - 410px);
  & + .prices-table{
    margin-top: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Subscriptions/Prices.vue